export const getWorkflowDisplayName = (wf: {
  displayName?: string | null;
  name?: string | null;
}) => wf.displayName || wf.name || "";
